import React, { Component } from 'react';

class Forecast extends Component {
  getDefaultProps() {
    return {
      height: 245,
      width: '100%'
    };
  }

  render() {
    let url = "//forecast.io/embed/#lat=" + this.props.latitude + "&lon=" + this.props.longitude + "&name=" + (this.props.name || '') + "&units=" + (this.props.units || '') + "&color=" + (this.props.color || '') + "&font=" + (this.props.font || '');

    return React.createElement('iframe', { key: this.props.latitude + "" + this.props.longitude, type: 'text/html', height: this.props.height, width: this.props.width, frameBorder: '0', src: url });
  }
}

export default Forecast;




// WEBPACK FOOTER //
// ./src/react-forecast.js